import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ScrollToTopButton from '../components/ScrollToTopButton';

// Styled Components
const ImpressumContent = styled.div`
  background-color: white;
  padding: 40px 30px;
  margin: 20px auto;
  border-radius: 10px;
  box-shadow: var(--shadow);
  max-width: 900px;
`;

const PageTitle = styled.h1`
  color: var(--primary-color);
  font-size: 2rem;
  margin-bottom: 25px;
  text-align: center;
`;

const ImpressumSection = styled.div`
  margin-bottom: 30px;
  
  h2 {
    color: var(--primary-color);
    font-size: 1.5rem;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid var(--accent-color);
  }
  
  p {
    margin-bottom: 10px;
  }
  
  a {
    color: var(--primary-color);
    word-break: break-all;
  }
`;

const Divider = styled.div`
  border-bottom: 2px solid var(--accent-color);
  margin: 15px 0 25px 0;
`;

function Impressum() {
  return (
    <>
      <div className="container">
        <ImpressumContent className="impressum-content">
          <PageTitle>Impressum</PageTitle>
          
          <ImpressumSection className="impressum-section">
            <h2>Angaben gemäß § 5 TMG</h2>
            <Divider className="divider" />
            <p>
              GuardiansMoves<br />
              Müllerstraße 3<br />
              13353 Berlin
            </p>
            
            <p>
              Handelsregister: -----------<br />
              Registergericht: Amtsgericht Charlottenburg-Berlin
            </p>
          </ImpressumSection>
          
          <ImpressumSection className="impressum-section">
            <h2>Vertreten durch</h2>
            <Divider className="divider" />
            <p>Galal Aldien Mghames</p>
          </ImpressumSection>
          
          <ImpressumSection className="impressum-section">
            <h2>Kontakt</h2>
            <Divider className="divider" />
            <p>
              Mobil: +49 155 6354 7378<br />
              E-Mail: info@guardiansmoves.de
            </p>
          </ImpressumSection>
          
          <ImpressumSection className="impressum-section">
            <h2>Umsatzsteuer-ID</h2>
            <Divider className="divider" />
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: ----------</p>
          </ImpressumSection>
          
          <ImpressumSection className="impressum-section">
            <h2>EU-Streitschlichtung</h2>
            <Divider className="divider" />
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a><br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </ImpressumSection>
          
          <ImpressumSection className="impressum-section">
            <h2>Verbraucherstreitbeilegung/<br />Universalschlichtungsstelle</h2>
            <Divider className="divider" />
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </ImpressumSection>
        </ImpressumContent>
      </div>
      
      <ScrollToTopButton />
    </>
  );
}

export default Impressum;